import React from 'react';
import { Link } from 'react-router-dom';
export default function NotFound() {
  return <section className="site-container" style={{paddingBlock: '90px'}}>
    <p className="site-eyebrow">404 – Sidan finns inte</p>
    <h1>Sidan hittades inte.</h1>
    <p>Länken kan ha ändrats. På startsidan hittar du våra tjänster, paket och kontaktuppgifter.</p>
    <Link className="site-button" to="/">Till startsidan</Link>
  </section>;
}
